import { Component, OnInit } from '@angular/core';
import {DetailedRegistration, ParticipantsCounter} from '../datamodel/registration';
import {CourseGroup} from '../datamodel/course-group';
import {Course} from '../datamodel/course';
import {ActivatedRoute} from '@angular/router';
import {LeftMenuService} from '../left-menu.service';
import {BackendService} from '../backend.service';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.css']
})
export class CourseComponent implements OnInit {

  registration: DetailedRegistration;
  courseGroup: CourseGroup;
  course: Course;
  counter: ParticipantsCounter;

  constructor(public route: ActivatedRoute, public menu: LeftMenuService, public backend: BackendService) {
  }

  ngOnInit() {
    this.route.data.subscribe(
      data => {
        const courseGroupId = this.route.snapshot.paramMap.get('course_group_id');
        this.registration = data.registration as DetailedRegistration;
        if (courseGroupId !== '_') {
          this.courseGroup = this.registration.coursesGroups.find(g => g.id === courseGroupId);
        } else {
          this.courseGroup = new CourseGroup({
            id: '_',
            description: {pl: 'Wszystkie przedmioty', en: 'All courses'}
          });
        }
        const courseId = decodeURIComponent(this.route.snapshot.paramMap.get('course_id'));
        this.course = this.registration.courses.find(c => c.courseId === courseId);
        this.menu.addPath([this.registration, this.courseGroup, this.course]);


        this.backend.getRegisteredCount(this.registration.id).subscribe(
          counter => this.counter = counter
        );
      }
    );
  }

}
